import { render, staticRenderFns } from "./KPanel.vue?vue&type=template&id=23d9f0ba&"
import script from "./KPanel.vue?vue&type=script&lang=js&"
export * from "./KPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports